<template>
    <div v-show="isOpen" class="bg-white shadow overflow-hidden sm:rounded-lg mb-4">
        <div class="text-center py-4">
            Summary
        </div>
        <div v-if="summary" class="grid grid-cols-2 gap-5">
            <div class="col-span-2 border-t border-gray-200">
                <dl>
                    <div class="border-b px-4 py-3 grid grid-cols-3">
                        <div class="col-span-3 md:col-span-1">
                            <dt class="text-sm font-medium text-gray-500">
                                Property address
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {{ summary.register.address }}
                            </dd>
                        </div>

                        <div v-if="summary.register.name" class="col-span-3 md:col-span-1">
                            <dt class="text-sm font-medium text-gray-500">
                                Buildings / Zones / Floors :
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {{ summary.register.name }}
                            </dd>
                        </div>

                        <div class="col-span-3 md:col-span-1">
                            <dt class="text-sm font-medium text-gray-500">
                                Property :
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {{ summary.register.property_name }}
                            </dd>
                        </div>
                    </div>

                    <div class="border-b px-4 py-3 grid grid-cols-3">
                        <div class="col-span-3 sm:col-span-1">
                            <dt class="text-sm font-medium text-gray-500">
                                Asbestos Register Reference :
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {{ summary.register.reference }}
                            </dd>
                        </div>
                        <div class="col-span-3 sm:col-span-1">
                            <dt class="text-sm font-medium text-gray-500">
                                Register Source :
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {{ summary.register.register_source }}
                            </dd>
                        </div>
                    </div>

                    <div v-if="summary.register.scope_of_work" class="border-b px-4 py-3 grid grid-cols-3">
                        <div class="col-span-3 sm:col-span-1">
                            <dt class="text-sm font-medium text-gray-500">
                                Scope of Register :
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {{ summary.register.scope_of_work }}
                            </dd>
                        </div>
                    </div>

                    <div class="border-b px-4 py-3 grid grid-cols-3">

                        <div v-if="showRegisterDate" class="col-span-3 sm:col-span-1">
                            <dt class="text-sm font-medium text-gray-500">
                                Register Date :
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {{ summary.register.register_date }}
                            </dd>
                        </div>

                        <div class="col-span-3 sm:col-span-1">
                            <dt class="text-sm font-medium text-gray-500">
                                Subscription Renewal Date :
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {{ summary.register.renewal_date }}
                            </dd>
                        </div>

                        <div class="col-span-3 sm:col-span-1">
                            <dt class="text-sm font-medium text-gray-500">
                                Re-inspection Due Date :
                            </dt>
                            <dd class="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                                {{ summary.register.review_date }}
                            </dd>
                        </div>
                    </div>

                    <div class="border-b px-4 py-3 grid grid-cols-3 text-sm">
                        <div class="col-span-3 sm:col-span-1">
                            {{ summary.acms.total }} ACMs
                        </div>
                        <div class="col-span-3 sm:col-span-1 text-red-600">
                            {{ summary.acms.high_risk }} High Risk
                        </div>
                        <div class="col-span-3 sm:col-span-1 text-orange-600">
                            {{ summary.acms.medium_risk }} Medium Risk
                        </div>
                        <div class="col-span-3 sm:col-span-1 text-green-700">
                            {{ summary.acms.low_risk }} Low Risk
                        </div>
                        <div class="col-span-3 sm:col-span-1 text-green-300">
                            {{ summary.acms.very_low_risk }} Very Low Risk
                        </div>
                        <div class="col-span-3 sm:col-span-1">
                            {{ summary.acms.no_asbestos }} No Asbestos Detected
                        </div>
                        <div class="col-span-3 sm:col-span-1">
                            {{ summary.acms.removed }} ACMs Removed
                        </div>
                    </div>

                    <div class="border-b px-4 py-3 grid grid-cols-3 text-sm">
                        <div class="col-span-3 sm:col-span-1 text-red-600">
                            {{ summary.no_access_areas.total }} No Access Areas
                        </div>
                    </div>
                </dl>
            </div>
        </div>
    </div>
    <button :disabled="loading" @click="isOpen = !isOpen" class="mb-4 w-full inline-flex justify-center py-2 px-4 border border-uknar-primary-dark shadow-sm text-sm font-medium rounded-md text-white bg-uknar-primary hover:bg-uknar-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-uknar-primary">
        <template v-if="loading">Loading</template>
        <template v-else-if="summary && !isOpen">View summary for {{ summary.register.name ?? summary.register.property_name }}</template>
        <template v-else-if="isOpen">Hide summary</template>
    </button>
</template>

<script>
import SaveButton from "../../components/form/SaveButton";
export default {
    name: 'RegisterSummary',
    components: {SaveButton},
    props: {
        registerId: {
            type: Number,
            required: true
        },
        showRegisterDate: {
            default: false
        }
    },

    data() {
        return {
            summary: null,
            loading: false,
            isOpen: false
        }
    },

    mounted() {
        this.loadSummary();
    },

    methods: {
        loadSummary() {
            axios.get(route('ajax.registers.summary', this.registerId))
                .then(response => {
                    this.summary = response.data.data
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>
